import { render, staticRenderFns } from "./StudentSignupList.vue?vue&type=template&id=1165e87c&"
import script from "./StudentSignupList.vue?vue&type=script&lang=js&"
export * from "./StudentSignupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports